"use client"

import { Button } from "@/elements"
import { DeclineJobInvitationDocument } from "@/gql/graphql"
import { useMutation } from "@apollo/client"
import { FC, useCallback, useMemo } from "react"
import { toast } from "@/components/Toast"
import type { NovaSession } from "@/types"

interface Props {
  invitationId: string | null | undefined
  onApply: () => void
  serverSession: NovaSession
}

export const JobDetailsFooterAcceptOrDeclineInviteCTAs: FC<Props> = props => {
  const { invitationId, onApply, serverSession } = props
  const [declineJobInvitation, { loading: declineJobInvitationLoading }] = useMutation(DeclineJobInvitationDocument, {
    refetchQueries: ["CreativeJobsInvitations"],
    awaitRefetchQueries: true,
  })

  const isCreative = serverSession.account === "creative"

  const refetchQueries = useMemo(
    () => (isCreative ? ["AuthenticatedJobPostingCreativeViewer"] : ["AuthenticatedJobPostingClientViewer"]),
    [isCreative]
  )

  const handlDeclineInvitations = useCallback(async () => {
    try {
      if (!invitationId) {
        toast.error("Invitation not found")
        return
      }
      const res = await declineJobInvitation({
        variables: { invitationId },
        refetchQueries,
      })
      if (res.data?.declineJobInvitation?.ok) {
        toast.success("Invitation declined")
      } else {
        throw new Error("Failed to decline invitation")
      }
    } catch (error) {
      toast.error("Failed to decline invitation")
    }
  }, [invitationId, declineJobInvitation, refetchQueries])

  return (
    <div className="flex flex-row gap-x-2">
      <Button
        className="md:hidden"
        variant="tertiary"
        onClick={handlDeclineInvitations}
        loading={declineJobInvitationLoading}>
        Decline
      </Button>
      <Button
        variant="tertiary"
        size="large"
        className="hidden md:block"
        onClick={handlDeclineInvitations}
        loading={declineJobInvitationLoading}>
        Decline
      </Button>
      <Button className="md:hidden" onClick={onApply} disabled={declineJobInvitationLoading}>
        Apply
      </Button>
      <Button onClick={onApply} size="large" className="hidden md:block" disabled={declineJobInvitationLoading}>
        Apply
      </Button>
    </div>
  )
}
